<app-transloco-root>
  <ion-app [attr.data-version]="version">
    <p-toast />
    <p-confirmdialog />
    <ion-router-outlet #routerOutlet></ion-router-outlet>
    <app-gesture-refresher [eventTarget]="routerOutlet"></app-gesture-refresher>
    <app-floatover></app-floatover>
  </ion-app>
</app-transloco-root>
